import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModule, Form, IconWithMenu, Link, Text,
} from '@domain-group/suit-theme'

import { useAgencyForm } from '@hooks/useAgency'

type AgencyPrincipalProps = {
  agencyFormPayload: ReturnType<typeof useAgencyForm>,
}

const AgencyPrincipal = (props: AgencyPrincipalProps) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      principal_email,
      principal_mobile,
      principal_name,
    },
    errors,
    handlers,
  } = agencyFormPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <IconWithMenu
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faInfoCircle} />
            </Link>
          )}
        >
          {/*
           // @ts-expect-error TS2741 */}
          <IconWithMenu.Menu closeOnClick>
            <Text color="bodyFontLightColor" padding="large" width={300}>
              Your agency principal may be contacted for important communication between realhub and the agency.
            </Text>
          </IconWithMenu.Menu>
        </IconWithMenu>
    )}
      title="Agency Principal"
    >
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.principal_name} label="* Name">
            <input
              name="principal_name"
              type="text"
              value={principal_name}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2339 */}
          <Form.Field errorMessage={errors.principal_mobile} label="* Mobile" marginTop={['large', 0]}>
            <input
              name="principal_mobile"
              type="text"
              value={principal_mobile}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Field errorMessage={errors.principal_email} label="* Email" marginTop="large">
          <input
            name="principal_email"
            type="email"
            value={principal_email}
            {...handlers}
          />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

export default AgencyPrincipal
